const validationErrorLabelMap = {
    CONTAINS_MUTUALLY_EXCLUSIVE_PRODUCT_TYPES: 'validations.containsMutuallyExclusiveProductTypes',
    HAS_VALID_OPTICIAN_DETAILS: 'validations.prescriptionGlassesInvalidBundleCombination',
    HAS_VALID_PRESCRIPTION_DATA_RANGES: 'validations.prescriptionGlassesInvalidBundleCombination',
    IS_IN_STOCK: 'validations.unavailableProductsInCart',
    IS_VALID_AMOUNT_OF_MASTER_VARIANTS: 'validations.maxMasterVariantQuantityExceeded',
    IS_VALID_CART_BY_PRESCRIPTION: 'validations.quantityExceededPrescriptionExpiryDate',
    IS_VALID_EXPIRY_DATE: 'validations.quantityExceededPrescriptionExpiryDate',
    IS_VALID_QUANTITY: 'validations.maxQuantitySkuExceeded',
    MAX_QUANTITY_PER_LINE_ITEM_TYPE: 'validations.maxVariantsPerProductTypeQuantityExceeded',
    MAX_QUANTITY_PER_PRODUCT_TYPE: 'validations.maxVariantsPerProductTypeQuantityExceeded',
    MAX_VARIANTS_PER_PRODUCT_TYPE: 'validations.maxVariantsPerProductTypeQuantityExceeded',
    ONE_LENS_TYPE_PER_EYE: 'validations.oneLensTypePerEye',
    PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT: 'validations.unavailableProductsInCart',
    PRODUCTS_ARE_PUBLISHED: 'validations.unavailableProductsInCart',
    REQUIRED_PRODUCT_TYPES_ARE_IN_BUNDLE: 'validations.prescriptionGlassesInvalidBundleCombination',
    VALID_CART_BY_PRODUCT_TYPES: 'validations.prescriptionGlassesInvalidBundleCombination',
    VALID_RELATIONS_BUNDLE_PRODUCTS: 'validations.prescriptionGlassesInvalidBundleCombination'
};
const getValidationErrorCodes = (validationInput)=>{
    if (!validationInput) {
        return [];
    }
    const lineItemValidationErrors = validationInput.cartLineItemErrors;
    if (lineItemValidationErrors) {
        return getLineItemValidationErrorCodes(lineItemValidationErrors);
    }
    return [];
};
const getLineItemValidationErrorCodes = (lineItemValidationErrors)=>{
    if (!lineItemValidationErrors) return [];
    const codes = lineItemValidationErrors.reduce((accumulator, currentValue)=>{
        const validationCode = currentValue.errors.map((error)=>error.validationCode
        );
        return [
            ...accumulator,
            ...validationCode
        ];
    }, []);
    const uniqueValidationCodes = [
        ...new Set(codes)
    ];
    return uniqueValidationCodes.map((code)=>validationErrorLabelMap[code]
    );
};

export { getValidationErrorCodes, validationErrorLabelMap };
//# sourceMappingURL=get-validation-error-codes.js.map
